import React, { ReactElement } from 'react';
import { Modal } from 'antd';
import { ArrowRightOutlined, CloseOutlined } from '@ant-design/icons';
import { onboardingStyles } from './OnboardingModal.styles';

interface OnboardingModalProps {
  open: boolean;
  onClose: () => void;
  image: string;
  content: ReactElement;
  title: string;
  buttonText?: string;
  onButtonClick?: () => void;
  isVideo?: boolean;
  badge?: string;
}

const OnboardingModal: React.FC<OnboardingModalProps> = ({
  open,
  onClose,
  image,
  buttonText = 'Get Started',
  content,
  title,
  onButtonClick,
  isVideo = false,
  badge,
}) => {
  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={900}
      centered
      className={onboardingStyles.modal}
      closeIcon={<CloseOutlined />}>
      <div className={onboardingStyles.container}>
        <div className={onboardingStyles.imageSection}>
          <img
            src={image}
            alt="Onboarding"
            className={isVideo ? onboardingStyles.video : onboardingStyles.image}
          />
        </div>

        <div className={onboardingStyles.contentSection}>
          <div className={onboardingStyles.header}>
            {badge && <div className={onboardingStyles.badge}>{badge}</div>}
            <h1 className={onboardingStyles.title}>{title}</h1>
          </div>

          <div className={onboardingStyles.content}>{content}</div>

          <div className={onboardingStyles.buttonContainer}>
            <button className={onboardingStyles.nextButton} onClick={handleButtonClick}>
              {buttonText}
              <ArrowRightOutlined />
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OnboardingModal;
